import './SchoolProfilePlaceholder.css';
import React from 'react';
import { Box, Typography, Alert } from '@mui/material';
import { Link } from 'react-router-dom';

const SchoolProfilePlaceholder = ({ schoolVerificationDocument }) => {

  const placeholderImageUrl = '/uploads/school-profiles/school-logo-placeholder.png';

  return (
    <Box
      sx={{
        maxWidth: '800px',
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem',
      }}
    >

      <Box sx={{ border: '1px solid #ccc', borderRadius: '8px', ml: '2rem', mt: '2.7rem'}}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '50px',
            borderBottom: '2px solid #e0e0e0',
            backgroundColor: '#f9f9f9',
            borderTopLeftRadius: '8px',
            borderTopRightRadius: '8px',
          }}
        >
          <Typography
            variant="h5" // Etwas kleiner für bessere Integration
            sx={{
              color: '#333', // Dezenter Farbton
              letterSpacing: '0.5px' // Leichte Abstände für mehr Eleganz
            }}
          >
            Schulprofil
          </Typography>
        </Box>
        {/* Nachricht basierend auf schoolCertificate */}
      {schoolVerificationDocument ? (
        <Box
          sx={{
            borderRadius: '8px',
            mt: '1rem',
            ml: '2rem',
            mr: '2rem',
          }}
        >
          <Alert severity="warning">
            Ihr Nachweis wird derzeit überprüft und sollte in Kürze bearbeitet werden.
          </Alert>
        </Box>
      ) : (
        <Box
          sx={{
            backgroundColor: 'rgba(255, 0, 0, 0.1)',
            borderRadius: '8px',
            color: '#d32f2f',
            mt: '1rem',
            ml: '1rem',
            mr: '1rem',
          }}
        >
          <Alert severity="error">
            Um auf das Schulprofil zugreifen zu können, müssen Sie in Ihrem{' '}
            <Link to="/pages/user-profile" style={{ textDecoration: 'none', color: 'blue', cursor: 'pointer' }}>
              Benutzerprofil
            </Link>{' '}
             Ihre Schule eintragen und einen entsprechenden Nachweis hochladen, dass Sie an dieser Schule angestellt sind.<br /> 
            Nach erfolgreicher Prüfung Ihres Nachweises erhalten Sie Zugriff auf Ihr Schulprofil und den Schullogbuch-Konfigurator.
          </Alert>
        </Box>
      )}
      {/* Platzhalteranzeige */}
      <Box
        sx={{
          position: 'relative',
          padding: '1rem',
        }}
      >
        {/* Verschwommene Balken als Platzhalter */}
        {['Schullogo/-flagge', 'Name der Schule', 'Identifikationsnummer', 'Straße', 'PLZ', 'Ort', 'E-Mail', 'Telefonnummer'].map(
          (label, index) => (
            <Box className={"placeholder-item-" + index} key={index} sx={{ marginBottom: '1rem' }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: '#3f51b5' }}>
                {label}:
              </Typography>
              {label.startsWith('Schullogo') && (
                <img
                alt="Schullogo/-flagge"
                src={placeholderImageUrl}
                style={{
                  width: '100px',
                  height: '100px',
                  objectFit: 'cover',
                  borderRadius: '8px',
                }}
              />
              )}
              <Box
                className={"placeholder-" + index}
                sx={{
                  width: '100%',
                  height: '1.5rem',
                  backgroundColor: '#e0e0e0', // Farbe für Platzhalterbalken
                  borderRadius: '4px',
                }}
              />
            </Box>
          )
        )}
      </Box>
      </Box>
    </Box>
  );
};

export default SchoolProfilePlaceholder;
